module.exports = __webpack_public_path__ + "img/model_k750v_small.0edb0ec2.png";